import { render, staticRenderFns } from "./SigninStaff.vue?vue&type=template&id=f0401038"
import script from "./SigninStaff.vue?vue&type=script&lang=js"
export * from "./SigninStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports